import { SvgIconOwnProps } from '@mui/material';
import {
  RemixiconComponentType,
  RiCheckboxCircleFill,
  RiErrorWarningLine,
  RiIndeterminateCircleLine,
} from '@remixicon/react';

export enum StatusIcon {
  Pending = 'pending',
  Completed = 'completed',
  Error = 'error',
  Warning = 'warning',
}

export const getIconElementForStatus = (
  iconStatus: StatusIcon,
): RemixiconComponentType | null => {
  switch (iconStatus) {
    case StatusIcon.Completed:
      return RiCheckboxCircleFill;
    case StatusIcon.Pending:
      return RiIndeterminateCircleLine;
    case StatusIcon.Warning:
    case StatusIcon.Error:
      return RiErrorWarningLine;
    default:
      return null;
  }
};

export const getIconColorForStatus = (
  iconStatus: StatusIcon,
): SvgIconOwnProps['color'] => {
  switch (iconStatus) {
    case StatusIcon.Completed:
      return 'success';
    case StatusIcon.Pending:
      return 'disabled';
    case StatusIcon.Warning:
      return 'warning';
    case StatusIcon.Error:
      return 'error';
    default:
      return 'disabled';
  }
};
